<template>
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="card mb-4">
            <div class="card-body">
                <div class="row">
                    <h1>Welcome to My Vue App</h1>
                    <p>This is the homepage.</p>

                    
                </div>
            </div>
        
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Home',
        created() {
            const token = localStorage.getItem('user');
            if (!token) {
                this.$router.push('/login'); // Redirect to login if no token found
            } else {
                // You could add an API call to verify the token here if needed
                //this.username = 'User'; // Assume the backend sends the username in the response
            }
        },
    };
</script>

<style scoped>
    h1 {
        color: #42b983;
    }
</style>
